export default "__VITE_ASSET__D0Op$mFb__"